import { Component, OnInit } from '@angular/core';
import { RouteService } from '@services/route.service';
import { CartService } from '@services/cart.service';
import { TrackingService } from 'src/app/services/tracking.service';

@Component({
  selector: 'gob-ok-payment',
  templateUrl: './ok-payment.component.html',
  styleUrls: ['./ok-payment.component.css']
})
export class OkPaymentComponent implements OnInit {

  constructor(private cart: CartService, public route: RouteService, private tracking: TrackingService) {
  }

  ngOnInit(): void {
    // Trigger Facebook Pixel Purchase event
    this.tracking.trackMeta('Purchase', {
      value: this.cart.getAmount(),
      currency: 'EUR',
      content_type: 'product',
      contents: this.cart.getLines(),
    });

    // Google Ads
    this.tracking.trackPurchase(
      this.cart.getAmount()
    );

    this.cart.clear();

  }

}
